// extracted by mini-css-extract-plugin
export default {"button":"SendButton_button__6fcjG"};